const apolloConfig = {
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT
};

export default apolloConfig;
